import React from 'react';
import Blogs from '../components/BlogPost/BlogSetup';


function Blog () {
  return (
    <div>       
        <h1 className='text-4xl font-bold text-blue-800 ml-10 mt-5'>Blogs</h1>
        <Blogs />
      </div>
  );
}


export default Blog;